import { findEasterEgg } from '../app/state';

export interface EasterEggDefinition {
  id: string;
  /** Suite exacte de hotspots à activer, dans l'ordre. */
  sequence?: string[];
  /** Ou : le même hotspot activé plusieurs fois d'affilée. */
  streak?: { hotspotId: string; count: number };
  message: string;
}

const definitions: EasterEggDefinition[] = [];
let history: string[] = [];
let streakHotspot = '';
let streakCount = 0;

export function registerEasterEggs(list: EasterEggDefinition[]): void {
  definitions.push(...list);
}

export function allEasterEggs(): readonly EasterEggDefinition[] {
  return definitions;
}

function longestSequence(): number {
  return definitions.reduce((max, egg) => Math.max(max, egg.sequence?.length ?? 0), 1);
}

function endsWith(sequence: string[]): boolean {
  if (sequence.length > history.length) return false;
  const tail = history.slice(-sequence.length);
  return tail.every((id, index) => id === sequence[index]);
}

/**
 * Renvoie l'easter egg découvert par cette activation, et seulement la
 * première fois. Un easter egg déjà trouvé ne se redéclenche pas.
 */
export function noteActivation(hotspotId: string): EasterEggDefinition | null {
  streakCount = hotspotId === streakHotspot ? streakCount + 1 : 1;
  streakHotspot = hotspotId;

  history.push(hotspotId);
  const maxLength = longestSequence();
  if (history.length > maxLength) history = history.slice(-maxLength);

  for (const egg of definitions) {
    const matchedStreak =
      egg.streak !== undefined &&
      egg.streak.hotspotId === hotspotId &&
      streakCount >= egg.streak.count;
    const matchedSequence = egg.sequence !== undefined && endsWith(egg.sequence);
    if (!matchedStreak && !matchedSequence) continue;

    if (findEasterEgg(egg.id)) {
      if (matchedStreak) streakCount = 0;
      return egg;
    }
  }

  return null;
}

/** Remet à zéro la progression en cours, sans toucher aux easter eggs déjà trouvés. */
export function resetEggProgress(): void {
  history = [];
  streakHotspot = '';
  streakCount = 0;
}

/** Utilisé par les tests pour repartir d'un catalogue vide. */
export function clearEasterEggs(): void {
  definitions.length = 0;
  resetEggProgress();
}
